import cn from 'classnames';
import { Link } from 'react-router';
import { Avatar } from '../avatar';
import { Text } from '../typography';

type P = {
  fallbackPhoto?: string;
  // TODO: #87927 link is optional only because the pinned post card is itself a button that opens the post. A link inside that card would nest two interactive elements. When the card is no longer the click target, require link and delete the static span.
  link?: string;
  name: string;
  photoUrl?: string;
};

const NavigationPill = ({ fallbackPhoto, link, name, photoUrl }: P) => {
  const content = (
    <>
      {photoUrl ? (
        <div className="navigation-pill__avatar">
          <Avatar fallbackPhoto={fallbackPhoto} size="xs" src={photoUrl} />
        </div>
      ) : null}
      <Text ellipsis>{name}</Text>
    </>
  );

  if (link) {
    return (
      <Link className="navigation-pill" to={link}>
        {content}
      </Link>
    );
  }

  return <span className={cn('navigation-pill', 'navigation-pill--static')}>{content}</span>;
};

export default NavigationPill;
